/* eslint-disable import/no-anonymous-default-export */
export default {
  head: "تقرير المهمة",
  assigned: "المُكلّف",
  complete: "مكتمل",
  inProgress: "قيد التنفيذ",
  resolved: "تم حلها",
  reOpened: "أعيد فتحها",
  overdue: "مُتأخر",
  completedBefore: "مكتمل (قبل)",
  completedAfter: "مكتمل (بعد)",
  priorityPlaceHolder: "حدد الأولوية",
  sortByPlaceHolder: "حدد فرز حسب",
  staffPlaceHolder: "حدد الموظفين",
  sortByLabel: "ترتيب",
  staffLabel: "طاقم العمل",
  priorityLabel: "الأولوية",
  graphDataNotFound: "لا توجد بيانات متاحة للمخطط.",
  exportTasKFileName: "FOM_TASK_REPORT",
  donutDataNotFound: "لا توجد بيانات متاحة للرسم البياني.",
  exportAttendanceFileName: "FOM_ATTENDANCE_REPORT",
  exportPerformanceFileName: "FOM_PERFORMANCE_REPORT",
  exportWorkdloadFileName: "FOM_WORKLOAD_REPORT",
  recentTask: "المهمة الأخيرة",
  oldTask: "المهمة القديمة",
  owner: "مالك",
  self: "النفس",
  manager: "مدير",
  employee: "موظف",
  pa: "مساعد شخصي",
  generalManager: "المدير العام",
  all: "الكل / الفريق",
  vendor: "البائعين/الموردين",
  personalAssistant: "مساعد شخصي",
  hrManager: "مدير الموارد البشرية",
  po: "موظف مشتريات",
  hrOfficer: "ضابط الموارد البشرية",
};
